import { useQuery } from '@tanstack/react-query';
import {
  getAnnualTimetableCells,
  loadAnnualTimetableGradeCellsLocalCache,
} from '../../services/annualTimetableService';
import { schoolKeys } from '../keys';
import { cacheOnlyQueryOptions } from './cacheOnlyQuery';
import { lsInitialDataOptions } from './lsInitialData';
import type { SchoolGradeTermScope } from './types';

export type UseAnnualTimetableCellsQueryParams = SchoolGradeTermScope & {
  enabled?: boolean;
  forceNetwork?: boolean;
  cacheOnly?: boolean;
};

export function annualTimetableCellsQueryOptions(params: UseAnnualTimetableCellsQueryParams) {
  const {
    workspaceId,
    academicYear,
    termNumber,
    gradeId,
    enabled = true,
    forceNetwork = false,
    cacheOnly = false,
  } = params;
  const ls = loadAnnualTimetableGradeCellsLocalCache(workspaceId, academicYear, termNumber, gradeId);
  const hasLocalRows = ls.found && ls.rows.length > 0;

  return {
    queryKey: schoolKeys.annualTimetableCells(workspaceId, academicYear, termNumber, gradeId),
    enabled: enabled && !!workspaceId.trim() && !!gradeId.trim(),
    ...lsInitialDataOptions(hasLocalRows, ls.rows),
    ...cacheOnlyQueryOptions(cacheOnly),
    queryFn: () =>
      getAnnualTimetableCells(workspaceId, academicYear, termNumber, [gradeId], {
        forceNetwork: cacheOnly ? false : forceNetwork,
      }),
  };
}

export function useAnnualTimetableCellsQuery(params: UseAnnualTimetableCellsQueryParams) {
  return useQuery(annualTimetableCellsQueryOptions(params));
}
